import React from "react";

const Logo = () => {
  return (
    <div className="header">
      <h1>
        Key Battles
      </h1>
    </div>
  );
};

export default Logo;
